import React from 'react';

const Toggle = ({ options, value, onChange }) => (
  <div className="flex space-x-2">
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        className={`px-4 py-2 rounded transition ${
          value === option.value
            ? 'bg-blue-600 text-white'
            : 'bg-gray-200 text-gray-700'
        }`}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default Toggle;
